(() => {
  if (window.oisFacetFallbackInstalled) return;
  window.oisFacetFallbackInstalled = true;

  function destination(form) {
    const current = new URL(window.location.href);
    const target = new URL(form.action, current);
    // Keep the selected product-list view when submitting an alternate template.
    const view = current.searchParams.get('view');
    const params = new URLSearchParams(new FormData(form));
    params.delete('page');
    params.delete('section_id');
    for (const key of [...new Set(params.keys())]) {
      if (params.getAll(key).every(value => value === '')) params.delete(key);
    }
    const drawer = form.closest('#FacetDrawer');
    const sort = drawer && drawer.querySelector('select[name="sort_by"]');
    if (sort && sort.value) params.set('sort_by', sort.value);
    if (view) params.set('view', view);
    if (!params.has('sort_by') && current.searchParams.has('sort_by')) params.set('sort_by', current.searchParams.get('sort_by'));
    target.search = params.toString();
    return target;
  }

  function apply(form) {
    if (!form || !form.reportValidity()) return;
    const target = destination(form);
    if (target.href !== window.location.href) window.location.assign(target.href);
  }

  // The theme's Apply button only closes the drawer. Submit the current fields
  // explicitly, including a price input that has not yet emitted blur/change.
  document.addEventListener('click', event => {
    const button = event.target.closest('#FacetDrawer button[aria-controls="FacetDrawer"]:not([aria-label])');
    if (!button) return;
    const form = button.closest('#FacetDrawer').querySelector('form[is="facet-form"]');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    apply(form);
  }, true);

  // Native GET fallback for browsers that do not upgrade customized forms.
  document.addEventListener('change', event => {
    const sort = event.target.closest('select[is="facet-short"]');
    if (sort && typeof sort.updateFormParams !== 'function') {
      if (sort.closest('#FacetDrawer')) return;
      const target = new URL(window.location.href);
      target.searchParams.set('sort_by', sort.value);
      target.searchParams.delete('page');
      window.location.assign(target.href);
      return;
    }
    const form = event.target.closest('form[is="facet-form"]');
    if (!form || typeof form.renderSection === 'function' || form.closest('#FacetDrawer')) return;
    apply(form);
  });
  document.addEventListener('submit', event => {
    const form = event.target.closest('form[is="facet-form"]');
    if (!form || form.closest('#FacetDrawer')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    apply(form);
  }, true);
})();
